'use client';

import { c as _c } from "react/compiler-runtime";
import usePostsShared from '@shared/utils/hooks/usePosts';
import useContentUIRenderer from '../../hooks/useContentUIRenderer';
import { client } from '../../utils/trpc';
import Button from '../common/Button';
import Modal, { ModalContent, ModalFooter, ModalHeader } from '../HOC/Modal';
type Props = {
  closeHandler: () => void;
  postId: string;
  isDraft: boolean;
  discardPost?: (discarded: boolean) => void;
  draftContent?: string;
  isPrivate?: boolean;
  // Server-stored private posts delete through the API, not local SQLite.
  isServerPrivate?: boolean;
};
const PostDeleteConf = props => {
  const $ = _c(25);
  const {
    deletePost,
    deleteDraftPost
  } = usePostsShared(client);
  const {
    filterText
  } = useContentUIRenderer();
  let t0;
  if ($[0] !== deleteDraftPost || $[1] !== deletePost || $[2] !== props) {
    t0 = () => {
      props.isDraft ? props.discardPost && deleteDraftPost(props.postId, props.discardPost) : deletePost(props.postId, props.isPrivate && !props.isServerPrivate);
      props.closeHandler();
    };
    $[0] = deleteDraftPost;
    $[1] = deletePost;
    $[2] = props;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const deleteHandler = t0;
  const t1 = props.isDraft ? "Delete Draft?" : "Are you sure?";
  let t2;
  if ($[4] !== t1) {
    t2 = <h2>{t1}</h2>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props.closeHandler || $[7] !== t2) {
    t3 = <ModalHeader closeHandler={props.closeHandler}>{t2}</ModalHeader>;
    $[6] = props.closeHandler;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== filterText || $[10] !== props.draftContent || $[11] !== props.isDraft) {
    t4 = <ModalContent>{props.isDraft ? <p className="text-textPrimary">{props.draftContent ? filterText({
          content: props.draftContent,
          isFullLength: true
        }) : ""}</p> : <p className="text-textPrimary">You're about to delete your post. This action cannot be undone. Are you sure?</p>}</ModalContent>;
    $[9] = filterText;
    $[10] = props.draftContent;
    $[11] = props.isDraft;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== props.closeHandler) {
    t5 = <Button text="Cancel" variant="SECONDARY" borderTransparent={false} classNames="w-28" onClick={props.closeHandler} />;
    $[13] = props.closeHandler;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== deleteHandler) {
    t6 = <Button text="Delete" classNames="bg-destructive w-28" onClick={deleteHandler} />;
    $[15] = deleteHandler;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = <ModalFooter>{t5}{t6}</ModalFooter>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== props.closeHandler || $[21] !== t3 || $[22] !== t4 || $[23] !== t7) {
    t8 = <Modal closeHandler={props.closeHandler}>{t3}{t4}{t7}</Modal>;
    $[20] = props.closeHandler;
    $[21] = t3;
    $[22] = t4;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
};
export default PostDeleteConf;